import { render, staticRenderFns } from "./res-label.vue?vue&type=template&id=048b5498&scoped=true&"
import script from "./res-label.vue?vue&type=script&lang=js&"
export * from "./res-label.vue?vue&type=script&lang=js&"
import style0 from "./res-label.vue?vue&type=style&index=0&id=048b5498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048b5498",
  null
  
)

export default component.exports